import { getStoryBySlug } from '@cinch-nx/data-storyblok'
import { traceFunction } from '@core/datadog-server'
import { GetStaticProps, InferGetStaticPropsType } from 'next'
import { BrandPageStory } from './storyblok/storyblok'
import { GetStaticPropsContext } from 'next'

const getStoryProps = async (slug: string, preview = false) => {
  try {
    return await getStoryBySlug<BrandPageStory>(`brands/${slug}`, {
      version: preview ? 'draft' : 'published',
      resolve_relations:
        'CarsCarousel.financeRepresentativeExample,FinanceOffersCarousel.financeRepresentativeExample',
    })
  } catch {
    return
  }
}

const getStaticPropsfn: GetStaticProps = async ({
  params,
  preview = false,
}: GetStaticPropsContext) => {
  const slug = params?.slug as string
  const story = await getStoryProps(slug, preview)
  if (!story) return { notFound: true }

  return {
    props: {
      story,
      preview,
      layoutProps: {
        heroProps: story.content.hero[0],
        showBorderRadius: false,
      },
    },
    revalidate: 60,
  }
}

export const getStaticProps = traceFunction(
  'brandpage.getStaticProps',
  getStaticPropsfn,
)

export type BrandPageProps = InferGetStaticPropsType<typeof getStoryProps>
